module.exports = __webpack_public_path__ + "img/4g.436e405e.jpg";